// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"1b450ef6","348":"8d4dcc98","571":"83ec5630","924":"0e1ad80e"}[chunkId] + ".chunk.js";
};